import { Component, ViewChild, TemplateRef, ChangeDetectorRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-document-template',
  templateUrl: './document-template.component.html',
  styleUrls: ['./document-template.component.scss']
})
export class DocumentTemplateComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  documentTemplateDataForGrid: any = [];
  documentTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  allowedFileExtns: any = "*.*";
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  viewPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, private readonly cdr: ChangeDetectorRef, private readonly sessionTimeoutService: SessionTimeoutService) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages


  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.documentTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.documentTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.documentTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.documentTemplateDataForGrid = [];
    const data = {

      gridName: "DOCUMENT_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "DMS_DOCUMENT_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");


            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const documentTemplate of this.documentTemplateDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    documentTemplate[dataType.columnName] = documentTemplate[dataType.columnName] == 'Y';
                  }
                }

              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
            });
            this.message.gridList = this.documentTemplateDataForGrid;
            this.collectionSize = this.documentTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.documentTemplateDataForGrid.length / this.itemsPerPage);
            this.dynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  getDmsFoldersDetails: any = [];
  orgData: any;
  ngOnInit() {

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })
    this.appService.getDmsSettingVw().subscribe((data: any) => {

      if (data.allowedFileExtns != null) {
        this.allowedFileExtns = null;
        let extns = data.allowedFileExtns.split(",");
        for (const ext of extns) {
          this.allowedFileExtns = this.allowedFileExtns == null
            ? "." + ext.toLowerCase()
            : this.allowedFileExtns + ",." + ext.toLowerCase();
        }
      }

    })
    this.getcallMethod();

    this.appService.getDmsFoldersDetails().subscribe((data: any) => {
      this.getDmsFoldersDetails = data;
      this.selectBoxForFolderIdList();
    })

  }

  focusEmpty() {
    console.log();
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.documentTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.documentTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.documentTemplateDataForGrid == undefined) {
        return this.documentTemplateDataForGrid;
      }
      if (!this.documentTemplateDataForGrid.length) {
        return this.documentTemplateDataForGrid;
      }
      if (filter) {
        this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;
    for (const documentTemplate of this.documentTemplateDataForGrid) {
      documentTemplate.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.documentTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.documentTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  templateNameValue: any;
  updateReason: any;

  templateNameRequiredMsg: any;
  uploadInputValueRequiredMsg: any;
  updateReasonRequiredMsg: any;
  fieldValidation() {
    this.templateNameValue = document.getElementById('templateName') as HTMLInputElement;
    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;

    this.templateNameRequiredMsg = document.getElementById('templateName-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
    this.uploadInputValueRequiredMsg = document.getElementById('uploadInputValue-required-msg') as HTMLInputElement;

    if (this.documentTemplateFieldData.templateName == "") {
      this.templateNameValue.style.border = '1px solid red';
      this.templateNameRequiredMsg.style.display = 'block';
    } else {
      this.templateNameValue.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }
  }

  onFieldFocusout() {

    if (this.templateNameRequiredMsg != undefined) {
      this.templateNameValue.style.border = 'none';
      this.templateNameRequiredMsg.style.display = 'none';
    }

    if (this.updateReasonRequiredMsg != undefined) {
      this.updateReason.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    }

    if (this.deleteFiledValueRequiredMsg != undefined) {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  documentTemplateFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  multiSelectDropdownSettings: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: false,
    singleSelection: false,
  };

  selectedFolderIdList: any = [];
  folderIdListDropdown: any = [];

  selectBoxForFolderIdList() {
    for (const folder of this.getDmsFoldersDetails) {
      this.folderIdListDropdown = this.folderIdListDropdown.concat({
        valueExp: folder.folderId,
        displayExp: folder.folderName
      });
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.documentTemplateFieldData = {};
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Document Template";
    this.documentTemplateFieldData.templateName = '';
    this.documentTemplateFieldData.documentTypeCode = '';
    this.documentTemplateFieldData.folderIdList = '';
    this.uploadedTemplate = '';
    this.documentTemplateFieldData.isActive = true;
    this.selectedFolderIdList = [];
    this.templateToUpload = null;
    this.templateExtention = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataTemplateId: any;
  previousTemplateName: any;
  uploadedTemplate: any;
  getDmsDocumentTemplateVwEditData: any = [];
  filteredFolderIdListValue: any = [];
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.previousDataTemplateId = editRowData.TEMPLATE_ID;
    this.visibleReasonForUpdateField = true;

    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update Document Template";
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = "Info";
    }

    this.appService.getDmsDocumentTemplateVwDetailsByTemplateId(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      this.getDmsDocumentTemplateVwEditData = response;
      this.documentTemplateFieldData.templateId = this.getDmsDocumentTemplateVwEditData.templateId;
      this.documentTemplateFieldData.templateName = this.getDmsDocumentTemplateVwEditData.templateName;
      this.documentTemplateFieldData.documentTypeCode = this.getDmsDocumentTemplateVwEditData.documentTypeCode;
      this.documentTemplateFieldData.isActive = this.getDmsDocumentTemplateVwEditData.isActive == 'Y';

      if (this.getDmsDocumentTemplateVwEditData.folderIdList) {
        this.selectedFolderIdList = [];
        this.documentTemplateFieldData.foldersList = [];
        let splitedFolderIdListValues = this.getDmsDocumentTemplateVwEditData.folderIdList.split(',');
        if (splitedFolderIdListValues.length) {
          for (const folderIdValue of splitedFolderIdListValues) {
            this.filteredFolderIdListValue = this.getDmsFoldersDetails.filter((x: any) => x.folderId === +folderIdValue);
            if (this.filteredFolderIdListValue.length !== 0) {

              const folderName = this.filteredFolderIdListValue[0].folderName;

              this.documentTemplateFieldData.foldersList = this.documentTemplateFieldData.foldersList == null
                ? folderName
                : this.documentTemplateFieldData.foldersList + "," + folderName;
            }
          }
        } else {
          this.selectedFolderIdList = [];
          this.documentTemplateFieldData.foldersList = [];
        }
      } else {
        this.selectedFolderIdList = [];
        this.documentTemplateFieldData.foldersList = [];
      }

      if (this.getDmsDocumentTemplateVwEditData.template != null) {
        this.previousTemplateName = this.getDmsDocumentTemplateVwEditData.templateName;
        this.uploadedTemplate = this.getDmsDocumentTemplateVwEditData.template;
        this.templateExtention = this.getDmsDocumentTemplateVwEditData.templateExtn;
      }

      this.isProcessing = false;
    })
    this.templateToUpload = null;
    this.documentTemplateFieldData.updateReason = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  templateToUpload: File | null = null;
  templateExtention: any;
  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  preTemplateValidation: any;

  warningMsg: any = "";
  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  uploadTemplates(e: any) {
    this.templateToUpload = e.target.files[0];
    this.templateExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
    if (this.allowedFileExtns.includes(this.templateExtention)) {
      this.uploadSuccessMsg = document.getElementById('template-success-msg') as HTMLInputElement;
      this.uploadSuccessIcon = document.getElementById('template-success-icon') as HTMLInputElement;
      this.preTemplateValidation = document.getElementById('preDocument-validation') as HTMLInputElement;

      if (this.templateToUpload == undefined || this.templateToUpload == null) {
        this.uploadSuccessMsg.style.display = 'none';
        this.uploadSuccessIcon.style.display = 'none';
      } else {
        this.uploadSuccessMsg.style.display = 'block';
        this.uploadSuccessIcon.style.display = 'block';
        if (this.popupDataTitle.title == 'Info' || this.popupDataTitle.title == 'Update Document Template') {
          this.preTemplateValidation.style.display = 'none';
        }
      }

      const file: File = e.target.files[0];

      if (file) {
        const name = file.name.substring(0, file.name.lastIndexOf('.'));
        let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();

        const formData = new FormData();
        formData.append('file', file ?? '');
        formData.append("pageName", "ORG");
        formData.append("fileName", name);
        formData.append("extension", extension);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe({
            next: (data: any) => {
              this.isProcessing = false;
              if (data.resultType !== "S") {

                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.result,
                    type: data.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              }
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          })
      }
    } else {
      let warningMsgType = "E";
      this.warningMsg = this.templateExtention + " file type is not allowed, please choose allowed file type.";
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: this.warningMsg,
          type: warningMsgType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
    }
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  dataValues: any = {};
  templateByteValue: any;
  addAndEditFunction(documentTemplateFieldData: any) {
    this.isProcessing = true;
    let list = [];
    if (this.orgData.allowedFileExtns) {
      list = this.orgData.allowedFileExtns.split(",");
    };
    if (!list.includes(this.templateExtention?.toUpperCase()) && (!this.templateToUpload)) {
      this.templateToUpload = null;
      this.showSnackBar("Please choose the template", "E");
      this.isProcessing = false;
    }
    else
      if (documentTemplateFieldData.templateName == "") {
        this.fieldValidation();
        this.isProcessing = false;
      } else if (this.operationFlag == 'ADD') {

        this.documentTemplateFieldData.selectedFolderIdList = '';
        if (this.selectedFolderIdList.length) {
          for (let j = 0; j < this.selectedFolderIdList.length; j++) {
            this.documentTemplateFieldData.selectedFolderIdList += this.selectedFolderIdList[j];
            this.documentTemplateFieldData.selectedFolderIdList += j == this.selectedFolderIdList.length - 1 ? "" : ",";
          }
        } else {
          this.documentTemplateFieldData.selectedFolderIdList = null;
        }

        this.dataValues = {
          operation: 'I',
          templateName: this.documentTemplateFieldData.templateName,
          documentTypeCode: this.documentTemplateFieldData.documentTypeCode,
          folderIdList: this.documentTemplateFieldData.selectedFolderIdList,
          templateExtn: this.templateExtention,
          isActive: this.documentTemplateFieldData.isActive ? 'Y' : 'N'
        };
        const documentTemplateData = new FormData();
        documentTemplateData.append('file', this.templateToUpload ?? '');
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        documentTemplateData.append('dmsDocumentTemplateVwDto', blob);

        console.log("Data - ", blob);
        this.appService.createDmsDocumentTemplate(documentTemplateData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.isProcessing = false;
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        if (this.documentTemplateFieldData.updateReason == null || this.documentTemplateFieldData.updateReason == undefined || this.documentTemplateFieldData.updateReason == '') {

          this.updateReason = document.getElementById('updateReason') as HTMLInputElement;
          this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;
          this.updateReason.style.border = '1px solid red';
          this.updateReasonRequiredMsg.style.display = 'block';
          this.isProcessing = false;

        } else {
          delete documentTemplateFieldData.createdOn;
          delete documentTemplateFieldData.updatedOn;

          if (this.templateToUpload == null) {
            this.templateByteValue = this.uploadedTemplate;
          } else {
            this.templateByteValue = null;
          }

          this.documentTemplateFieldData.selectedFolderIdList = '';
          if (this.selectedFolderIdList.length != 0) {
            for (let j = 0; j < this.selectedFolderIdList.length; j++) {
              this.documentTemplateFieldData.selectedFolderIdList += this.selectedFolderIdList[j];
              this.documentTemplateFieldData.selectedFolderIdList += j == this.selectedFolderIdList.length - 1 ? "" : ",";
            }
          } else if (this.getDmsDocumentTemplateVwEditData.folderIdList) {
            this.documentTemplateFieldData.selectedFolderIdList = this.getDmsDocumentTemplateVwEditData.folderIdList;
          }


          console.log()
          this.dataValues = {
            operation: 'U',
            template: this.templateByteValue,
            templateId: this.previousDataTemplateId,
            templateName: this.documentTemplateFieldData.templateName,
            documentTypeCode: this.documentTemplateFieldData.documentTypeCode,
            folderIdList: this.documentTemplateFieldData.selectedFolderIdList,
            templateExtn: this.templateExtention,
            isActive: this.documentTemplateFieldData.isActive ? 'Y' : 'N',
            updateReason: this.documentTemplateFieldData.updateReason
          };
          const documentTemplateData = new FormData();
          documentTemplateData.append('file', this.templateToUpload ?? '');
          const json = JSON.stringify(this.dataValues);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          documentTemplateData.append('dmsDocumentTemplateVwDto', blob);

          console.log("Data - ", blob);
          this.appService.updateDmsDocumentTemplate(documentTemplateData).subscribe({
            next: (Response: any) => {
              if (Response.resultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.getcallMethod();
                this.isProcessing = false;
              }
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok",
                  pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deletingDocumentTemplate: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Document Template";
    this.deletingDocumentTemplate = deleteRowData;
    if (this.documentTemplateFieldData.deleteReason != undefined) {
      this.documentTemplateFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {
        templateId: this.deletingDocumentTemplate.TEMPLATE_ID,
        templateName: this.deletingDocumentTemplate.TEMPLATE_NAME,
        deleteReason: this.documentTemplateFieldData.deleteReason,
      }
      this.appService.deleteDmsDocumentTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  viewerData: any = {};
  downloadTemplates(list: any, columnName: any) {
    console.log(list);

    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
    this.appService.getDocumentToViewAudit(docObj).subscribe((response: any) => {
      this.isProcessing = false;
      console.log(response.headers);
      const header = response.headers.get('content-type');
      console.log(header);
      let binaryData = [];
      this.viewerData = {
        body: response.body,
        contentType: header,
        extn: list.TEMPLATE_EXTN
      }
      this.cdr.detectChanges();
    })
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.TEMPLATE_ID;
    this.auditTrail.gridName = 'DOCUMENT_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Document Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Document Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.filter((item: any) => item.fieldColumnarray !== 'Template')?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }


  visibleSearchFolderPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('searchFolderPopup', { static: true }) searchFolderPopup: TemplateRef<any>;
  searchFolderPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };



  searchByFolderName: any = "";
  isShowSearchedFolderGrid = false;
  searchFoldersForTemplate() {
    this.searchByFolderName = "";
    this.getSelectedFolderNameList = [];
    this.getselectedFolderIdList = [];
    this.selectedFolderIdList = [];
    this.documentTemplateFieldData.foldersList = null;
    this.isShowSearchedFolderGrid = false;
    this.visibleSearchFolderPopup = this.dialog.open(this.searchFolderPopup, this.searchFolderPopupConfig);
  }


  gridResetFunction() {
    this.searchByFolderName = "";
    this.searchedFolderList = [];
    this.isShowSearchedFolderGrid = false;
  }

  searchedFolderList: any = [];
  seachFolderFunc() {
    this.isShowSearchedFolderGrid = true;
    this.getSelectedFolderNameList = [];
    this.getselectedFolderIdList = [];
    this.selectedFolderIdList = [];
    this.documentTemplateFieldData.foldersList = null;
    this.isProcessing = true;
    if (this.searchByFolderName == "") {
      this.searchByFolderName = undefined;
    }
    this.appService.searchFolderByFolderName(this.searchByFolderName).subscribe((data: any) => {
      this.searchedFolderList = data;
      this.isProcessing = false;
    })
  }

  searchFolderParentCheckBox = false;
  searchFolderDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.searchFolderParentCheckBox = true;
      for (const folder of this.searchedFolderList) {
        this.selectedFolderIdList.push(folder.folderId);
        this.getSelectedFolderNameList.push(folder.folderName);
      }
    } else {
      this.searchFolderParentCheckBox = false;
      this.getselectedFolderIdList = [];
      this.getSelectedFolderNameList = [];
    }
  }

  getSelectedFolderNameList: any = [];
  getselectedFolderIdList: any = [];
  searchFolderChildCheckBoxChecked(e: any, task: any, index: any) {
    if (e.target.checked) {
      task.searchFolderChildCheckBoxs = true;
      this.getselectedFolderIdList.push(task.folderId);
      this.getSelectedFolderNameList.push(task.folderName);
    } else {
      task.searchFolderChildCheckBoxs = false;
      this.getselectedFolderIdList.splice(this.getselectedFolderIdList.indexOf(task.folderId), 1);
      this.getSelectedFolderNameList.splice(this.getSelectedFolderNameList.indexOf(task.folderName), 1);
    }
  }


  addFolderFunction() {
    this.selectedFolderIdList = this.getselectedFolderIdList;
    for (const folderName of this.getSelectedFolderNameList) {
      this.documentTemplateFieldData.foldersList = this.documentTemplateFieldData.foldersList == null
        ? folderName
        : this.documentTemplateFieldData.foldersList + "," + folderName;
    }

    this.visibleSearchFolderPopup.close();
  }

  cancelFolderFunction() {
    this.visibleSearchFolderPopup.close();
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel)
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  validateTemplateName(event: any) {
    if (event.key === '.') {
      event.preventDefault();
    }
  }
  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }
}
